import { Badge, badgeClasses, styled, Typography } from "@mui/material";

import theme from "fond/theme";
import { withDefaultProps } from "fond/utils/withDefaultProps";

export const NotificationSubject = styled(withDefaultProps(Typography, { variant: "h5" }))`
  font-size: ${theme.typography.size.small};
  margin-bottom: ${theme.spacing(0.5)};
`;

export const NotificationBody = styled(withDefaultProps(Typography, { variant: "body2" }))`
  font-size: ${theme.typography.size.small};
  color: ${theme.palette.biarri.primary.darkGrey};
`;

export const CountBadge = styled(withDefaultProps(Badge, { color: "secondary", overlap: "circular" }))`
  .${badgeClasses.badge} {
    min-width: ${theme.spacing(2)};
    height: ${theme.spacing(2)};
    padding-inline: ${theme.spacing(0.5)};
    font-size: ${theme.typography.size.small};
  }
`;
